import { render, staticRenderFns } from "./PayPlanVersionPane.vue?vue&type=template&id=2c0527ed&scoped=true"
import script from "./PayPlanVersionPane.vue?vue&type=script&setup=true&lang=js"
export * from "./PayPlanVersionPane.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PayPlanVersionPane.vue?vue&type=style&index=0&id=2c0527ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0527ed",
  null
  
)

export default component.exports